export default "__VITE_ASSET__8c931c8b__"